import React, { useEffect, createElement } from 'react';
import { AnnouncementBar } from './components/AnnouncementBar';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { TestimonialSection } from './components/TestimonialSection';
import { SolutionSection } from './components/SolutionSection';
import { OfferStack } from './components/OfferStack';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { SecondCTASection } from './components/SecondCTASection';
import { FAQSection } from './components/FAQSection';
import { Footer } from './components/Footer';
import { RecentPurchaseToast } from './components/RecentPurchaseToast';
declare global {
  interface Window {
    fbq: (...args: any[]) => void;
    _fbq: (...args: any[]) => void;
  }
}
export function App() {
  useEffect(() => {
    // Meta Pixel initialization
    if (!window.fbq) {
      const n: any = window.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!window._fbq) window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(t);
    }
    window.fbq('init', '25962343990086349');
    window.fbq('track', 'PageView');
  }, []);
  const testimonials1 = [{
    quote: 'Por fin entiendo por qué me sentía así',
    text: 'Llevaba 2 años luchando con la inflamación de mi abdomen. En 3 días con el protocolo SOS, mi vientre estaba visiblemente más plano.',
    name: 'Mariana G.',
    age: 34,
    image: 'https://cdn.magicpatterns.com/uploads/5NtzDiaMs2Ex7wK5rc6wzG/t1.png'
  }, {
    quote: 'Bajé 3 kilos sin dejar de comer',
    text: 'Entendí que podía comer carbohidratos en mi fase lútea sin culpa. Bajé 3 kilos en el primer mes sin dietas extremas.',
    name: 'Carla R.',
    age: 29,
    image: 'https://cdn.magicpatterns.com/uploads/rB4V72kixDtmnBQkkaJbgG/t2.png'
  }, {
    quote: 'Me cambió la relación con mi cuerpo',
    text: 'Siempre pensé que era yo la del problema. El Código Hormonal me dio un lenguaje para entender lo que me pasaba.',
    name: 'Sofía M.',
    age: 38,
    image: 'https://cdn.magicpatterns.com/uploads/u6vYoVo2c1jJ1X6dThXnWQ/t3.png'
  }];
  const testimonials2 = [{
    quote: 'Vale cada centavo y más',
    text: 'Dudé porque pensé que era otro PDF genérico. El recetario solo ya vale el precio completo. Lo recomiendo sin dudarlo.',
    name: 'Valeria T.',
    age: 31,
    image: 'https://cdn.magicpatterns.com/uploads/dGTsRZjBNhia28NE4jrWmM/t4.png'
  }, {
    quote: 'El calendario de ejercicios me cambió la vida',
    text: 'Llevaba años destruyéndome en el gym sin ver resultados. En 3 semanas noté la diferencia en mi energía y en mi peso.',
    name: 'Andrea L.',
    age: 27,
    image: 'https://cdn.magicpatterns.com/uploads/3eQxv6CgMf5qN4HTb2aYsF/t5.png'
  }, {
    quote: 'Ojalá lo hubiera encontrado antes',
    text: 'Tengo SOP y siempre pensé que mi cuerpo simplemente era así. Es el primer recurso que realmente habla de MI realidad.',
    name: 'Gabriela S.',
    age: 33,
    image: 'https://cdn.magicpatterns.com/uploads/qwd5UriJ32LMjFEw1CENJW/t6.png'
  }];
  return <div className="min-h-screen flex flex-col w-full font-body" data-id="element-0">
      <AnnouncementBar data-id="element-1" />
      <main className="flex-grow" data-id="element-2">
        <HeroSection data-id="element-3" />
        <PainSection data-id="element-4" />
        <TestimonialSection heading="Otras mujeres lo sienten igual... y ya lo resolvieron." testimonials={testimonials1} data-id="element-5" />
        <SolutionSection data-id="element-6" />
        <OfferStack data-id="element-7" />
        <TestimonialSection heading="Mujeres reales que ya tienen el pack completo:" testimonials={testimonials2} data-id="element-8" />
        <PricingSection data-id="element-9" />
        <GuaranteeSection data-id="element-10" />
        <SecondCTASection data-id="element-11" />
        <FAQSection data-id="element-12" />
      </main>
      <Footer data-id="element-13" />
      <RecentPurchaseToast data-id="element-14" />
    </div>;
}